<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar :logo="require('../../../public/img/brand/nuevo_logo.svg')">
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            path: '/dashboard',
            icon: 'fas fa-tachometer-alt text-orange',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="session.user && session.user.role === 'administrador'"
          :link="{
            name: 'Catalogos',
            icon: 'fas fa-books text-primary',
          }"
        >
          <sidebar-item
            :link="{ name: 'Sucursales', path: '/catalogos/sucursales' }"
          ></sidebar-item>
          <!-- <sidebar-item :link="{ name: 'Categorias', path: '/catalogos/categorias' }"></sidebar-item> -->
          <!-- <sidebar-item :link="{ name: 'Productos', path: '/catalogos/productos' }"></sidebar-item> -->

          <!-- <sidebar-item :link="{ name: 'Proveedores', path: '/catalogos/proveedores' }"></sidebar-item> -->
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Facturación',
            icon: 'fas fa-file-code text-primary',
          }"
        >
          <sidebar-item
            v-if="session.user && session.user.role === 'administrador'"
            :link="{ name: 'Panel', path: '/facturacion/' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Facturar', path: '/facturacion/factura-sucursal' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Buscador Tickets',
              path: '/facturacion/buscador-tickets',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Archivo Facturas', path: '/facturacion/archivo' }"
          ></sidebar-item>
          <sidebar-item
            v-if="
              session.user &&
              (session.user.role === 'administrador' ||
                session.user.role === 'supervisor')
            "
            :link="{
              name: 'Factura Global',
              path: '/facturacion/factura-global',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="session.user && session.user.role === 'administrador'"
            :link="{ name: 'PAC Sellos', path: '/PAC/sellos' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Facturación V2 (Pruebas)',
            icon: 'fas fa-file-code text-primary',
          }"
        >
          <sidebar-item
            v-if="
              session.user &&
              (session.user.role === 'administrador' ||
                session.user.role === 'supervisor')
            "
            :link="{
              name: 'facturacionv2-facturas',
              path: '/facturacionv2/facturas',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="session.user && session.user.role === 'administrador'"
            :link="{ name: 'PAC Sellos', path: '/PAC/sellos' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="session.user && session.user.role === 'administrador'"
          :link="{
            name: 'Albaranes',
            path: '/albaranes',
            icon: 'fas fa-file-alt text-primary',
          }"
        >
          <sidebar-item
            :link="{ name: 'Clientes', path: '/albaranes/clientes/' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Historico', path: '/albaranes/historico/' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-if="session.user && session.user.role === 'administrador'"
          :link="{
            name: 'Configuración',
            icon: 'ni ni-settings text-muted',
          }"
        >
          <!-- <sidebar-item
            :link="{ name: 'Empresa', path: '/configuracion/empresa' }"
          ></sidebar-item> -->
          <!-- <sidebar-item
            :link="{ name: 'Empleados', path: '/catalogos/empleados' }"
          ></sidebar-item> -->
          <sidebar-item
            :link="{ name: 'Usuarios', path: '/configuracion/usuarios' }"
          ></sidebar-item>
          <!-- <sidebar-item
            :link="{ name: 'Perfiles', path: '/configuracion/perfiles' }"
          ></sidebar-item> -->
        </sidebar-item>
      </template>

      <!-- <template slot="links-after">
        <hr class="my-3">
        <h6 class="navbar-heading p-0 text-muted">Documentation</h6>

        <b-nav class="navbar-nav mb-md-3">
          <b-nav-item
               href="https://www.creative-tim.com/learning-lab/bootstrap-vue/quick-start/argon-dashboard"
               >
              <i class="ni ni-spaceship"></i>
              <b-nav-text class="p-0">Getting started</b-nav-text>
          </b-nav-item>
          <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/colors/argon-dashboard">
              <i class="ni ni-palette"></i>
              <b-nav-text class="p-0">Foundation</b-nav-text>
          </b-nav-item>
          <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/avatar/argon-dashboard">
              <i class="ni ni-ui-04"></i>
              <b-nav-text class="p-0">Components</b-nav-text>
          </b-nav-item>
        </b-nav>
      </template> -->
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
  },
  computed: {
    ...mapState(["session"]),
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
  },
  mounted() {
    this.initScrollbar();
  },
};
</script>
<style lang="scss"></style>
